import React from 'react'

import {
  Box,
  Color,
  Display,
  FontFamily,
  Text,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

type SurchargeProps = {
  label: string | null
  variant: 'dark' | 'light' | 'value'
}

const variants: Record<'dark' | 'light' | 'value', { background: string | Color; color: Color }> = {
  dark: {
    background: Color.Secondary_600,
    color: Color.White,
  },
  light: {
    background: Color.ColdGrey_50,
    color: Color.ColdGrey_800,
  },
  value: {
    background: '#f3c435',
    color: Color.ColdGrey_800,
  },
}

export const Surcharge = ({ label, variant }: SurchargeProps) => {
  if (!label) {
    return null
  }

  const Wrapper = withCitrusTheme(Box, (theme) => {
    const { background, color } = variants[variant]
    return {
      alignContent: 'center',
      background: Object.values(Color).includes(background as Color)
        ? theme.color(background as Color)
        : background,
      color: theme.color(color),
    }
  })

  return (
    <Wrapper
      borderRadius={1.5}
      color={Color.White}
      display={Display.InlineBlock}
      paddingH={1}
      paddingV={0.5}
    >
      <Text fontFamily={FontFamily.Bold} size={2}>
        {label}
      </Text>
    </Wrapper>
  )
}
